// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__t4Ij3","alertIcon":"ConfirmModal_alertIcon__1qyCx"};